import React from 'react'
import { Trans } from '@lingui/macro'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import SendIcon from '@mui/icons-material/Send'
import { FormSubmission } from '@/core/models/form.model'
import { EthicsSubmissionDetail } from './EthicsSubmissionDetail'

type EthicsDetailDialogProps = {
  submission: FormSubmission
  onClose: () => void
  onRespond: () => void
}

export function EthicsDetailDialog({ submission, onClose, onRespond }: EthicsDetailDialogProps) {
  return (
    <Dialog open maxWidth="md" fullWidth onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ fontWeight: 700 }}>
        <Trans>Ethical Question Details</Trans>
      </DialogTitle>
      <DialogContent dividers>
        <EthicsSubmissionDetail submission={submission} />
      </DialogContent>
      <DialogActions sx={{ p: 2.5, gap: 1 }}>
        <Button onClick={onClose} sx={{ borderRadius: 3 }}>
          <Trans>Close</Trans>
        </Button>
        <Button
          variant="contained"
          color="primary"
          endIcon={<SendIcon sx={{ fontSize: '18px !important' }} />}
          onClick={onRespond}
          sx={{ borderRadius: 3, fontWeight: 700, px: 3 }}
        >
          <Trans>Respond</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
